import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  config: any;

  constructor(private readonly http: HttpBackend) { }

  loadAppConfig() {
    const timestamp = new Date().getTime();

    return new HttpClient(this.http).get('./assets/appConfig/appConfig.json' + '?t=' + timestamp)
      .toPromise()
      .then(config => {
        this.config = config;
      });
  }

}
